import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon
  const [settings, setSettings] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const loadSettings = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) { /* noop */ }
  }, []);

  const loadSubscription = useCallback(async () => {
    try {
      const { data } = await api.get("/subscription/mine");
      setSubscription(data.subscription);
    } catch (e) { setSubscription(null); }
  }, []);

  const loadNotifications = useCallback(async () => {
    try {
      const { data } = await api.get("/notifications");
      setNotifications(data);
    } catch (e) { /* noop */ }
  }, []);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("kor_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await Promise.all([loadSubscription(), loadNotifications()]);
    } catch (e) {
      localStorage.removeItem("kor_token");
      setUser(false);
    }
  }, [loadSubscription, loadNotifications]);

  useEffect(() => {
    loadSettings();
    refreshUser();
  }, [loadSettings, refreshUser]);

  const login = (token, u) => {
    localStorage.setItem("kor_token", token);
    setUser(u);
    loadSubscription();
    loadNotifications();
  };

  const logout = () => {
    localStorage.removeItem("kor_token");
    setUser(false);
    setSubscription(null);
    setNotifications([]);
  };

  const hasActiveSub = subscription?.status === "active";

  return (
    <AppContext.Provider value={{
      user, setUser, settings, subscription, hasActiveSub, notifications,
      login, logout, refreshUser, loadSubscription, loadNotifications, loadSettings,
    }}>
      {children}
    </AppContext.Provider>
  );
}
